const aboutRouter = {
  route: null,
  name: null,
  title: '关于睿正管理',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont icon-tushuguanli',
  filePath: 'view/about-us/', // 文件路径
  order: null,
  inNav: true,
  children: [
    {
      title: '睿正简介',
      type: 'view',
      name: 'AcetaleDesc',
      route: '/about-us/desc',
      filePath: 'view/about-us/acetale-desc.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      title: '核心优势',
      type: 'view',
      name: 'Advantage',
      route: '/about-us/advantage',
      filePath: 'view/about-us/advantage-list.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      title: '图墙管理',
      type: 'view',
      name: 'images',
      route: '/about-us/image-wall',
      filePath: 'view/about-us/image-wall.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      route: '/about-us/team',
      title: '关于我们',
      type: 'folder',
      name: null,
      filePath: 'view/about-us/team',
      icon: 'iconfont icon-tushuguanli',
      inNav: true,
      children: [
        {
          title: '合伙人团队',
          type: 'view',
          name: 'partner',
          route: '/about-us/team/partner',
          filePath: 'view/about-us/team/partner.vue',
          inNav: true,
          icon: 'iconfont icon-huiyuanguanli',
        },
        {
          title: '顾问团队',
          type: 'view',
          inNav: true,
          route: '/about-us/team/consultant',
          icon: 'iconfont icon-add',
          name: 'UserCreate',
          filePath: 'view/about-us/team/consultant.vue',
        },
      ],
    },
  ],
}

export default aboutRouter
